import { __assign } from "tslib";
/* I02 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var GiveBadge = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 20 18", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", null,
                React.createElement("path", { d: "M17 0l2.504 5.007-2.231.012L15.764 2H4.235L2.373 5.724 10 14.875l1.603-1.924 2.593.014L10 18 0 6l3-6h14zm1 7v2h2v2h-2v2h-2v-2h-2V9h2V7h2z" })))));
};
GiveBadge.displayName = 'GiveBadge';
export default GiveBadge;
//# sourceMappingURL=GiveBadge.js.map